export default "__VITE_ASSET__DmkGIalL__"